import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { requestActivityReport, clearActivityReport } from 'actionCreators';
import Validator from 'mixins/validator';
import SimpleRequest from 'mixins/simple_request';
import Loading from 'components/Loading';
import PageActionBar from 'components/PageActionBar';
import PhaseHistoryCard from 'components/PhaseHistoryCard';
import UserSearch from 'components/UserSearch';
import DatePicker from 'components/DatePicker';
import ColoredButton from 'components/ColoredButton';
import contentAreaStyles from 'styles/contentArea';
import { handleDateSave } from '../../../../../utils/dateUtils.js';
import EventType from 'types/event';
import PhaseType from 'types/phase';
import S from 'styles.scss';
import cx from 'classnames';

const DATE_MSG = 'Must be on or before end date';
const TOO_LONG_MSG = 'Maximum of 7 days may be returned';

class ActivityReport extends Validator(SimpleRequest(React.Component, 'ActivityReport')) {
  static VALIDATIONS = { user_id: true, start_date: true, end_date: true }

  constructor(props) {
    super(props);
    const query = this.props.location.query;
    this.state = {
      errors: {},
      user_id: query.user_id || null,
      start_date: moment(query.start_date).format('MM/DD/YYYY'),
      end_date: moment(query.end_date).format('MM/DD/YYYY'),
    };
  }

  onDateChange = kind => date => this.setState({ [kind]: date });

  onUserChange = val => this.setState({ user_id: val.id });

  submit = (e) => {
    e.preventDefault();
    if (!this.validate()) { return; }
    const { user_id: user, start_date, end_date } = this.state;
    const startMoment = moment(start_date, 'MM/DD/YYYY');
    const endMoment = moment(end_date, 'MM/DD/YYYY');
    if (endMoment.isBefore(startMoment)) {
      this.setState({ errors: { start_date: [DATE_MSG] } });
    } else if (endMoment.diff(startMoment, 'days') > 7) {
      this.setState({ errors: { end_date: [TOO_LONG_MSG] } });
    } else {
      const query = {
        user_id: user,
        start_date: handleDateSave(startMoment),
        end_date: handleDateSave(endMoment),
      };
      this.props.push({ pathname: this.props.location.pathname, query });
    }
  }

  render = () => {
    const { report: { loaded, loading, data } } = this.props;
    const { start_date: start, end_date: end, errors } = this.state;
    return (<div>
      <PageActionBar
        showAdd={false}
        showFiltersBtn={false}
        title="Activity Report"
      />
      <div className={contentAreaStyles.contentAreaContainer}>
        <div className={cx(contentAreaStyles.contentArea, S.noPrint, S.filters)}>
          <form onSubmit={this.submit} className={S.form}>
            <UserSearch
              label="User"
              required
              className={cx(S.formElement, S.select)}
              onChange={this.onUserChange}
              error={errors.user_id && errors.user_id.join(', ')}
            />
            <DatePicker
              className={S.formElement}
              label="Start Date"
              value={start}
              onChange={this.onDateChange('start_date')}
              placeholder="Select Date"
              error={errors.start_date && errors.start_date.join(', ')}
              required
            />
            <DatePicker
              className={S.formElement}
              label="End Date"
              value={end}
              onChange={this.onDateChange('end_date')}
              placeholder="Select Date"
              error={errors.end_date && errors.end_date.join(', ')}
              required
            />
            <div className={S.formBreak} />
            <ColoredButton type="submit">Run Report</ColoredButton>
          </form>
        </div>
        {loaded &&
          <PhaseHistoryCard
            name={`
              ${data.meta.user.name}
              (${moment(data.meta.start_date).format('MM/DD/YYYY')} – ${moment(data.meta.end_date).format('MM/DD/YYYY')})
                — ${data.events.length} Events
            `}
            events={data.events}
            collapsed={false}
          />
        }
        {loading && <Loading />}
      </div>
    </div>);
  }
}

ActivityReport.propTypes = {
  location: PropTypes.shape({
    query: PropTypes.objectOf(PropTypes.string).isRequired,
    search: PropTypes.string.isRequired,
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  report: PropTypes.shape({
    loaded: PropTypes.bool,
    data: PropTypes.shape({
      events: PropTypes.arrayOf(EventType),
      meta: PropTypes.shape({
        user: PropTypes.shape({
          name: PropTypes.string.isRequired,
        }),
      }),
    }),
  }),
  requestActivityReport: PropTypes.func.isRequired,
  clearActivityReport: PropTypes.func.isRequired,
  push: PropTypes.func.isRequired,
  phase: PhaseType,
};

export default connect(state => ({
  report: state.reports.activity,
  phase: state.phase.details,
}), { requestActivityReport, clearActivityReport, push })(ActivityReport);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/reports/activity/index.jsx